export const ROOT = "/";
export const SIGNIN = "/signin";
export const DEMO = "/demo";
export const DEFAULT = "/default";
export const MY_ACCOUNT = "/my-account";
export const NOTE = "/note";
export const NOTEBOOKS = "/notebooks";
export const ROUTE404 = "/404";
